import { useMemo } from 'react';

import { usePsfSharePageData } from '#src/app/pages/psf/share/pageContext';
import { getLocalSignerLocation } from '#src/app/pages/psf/shared/utils';
import type { LocalShareAction } from '#src/app/shared/components/localSignerShare';
import { useCurrentUser } from '#src/app/shared/hooks/session';

import { useShareActions } from '../../ShareActions/hooks/useShareActions';
import type { ShareActionItem } from '../../ShareActions/hooks/useShareActions/mapButtonConfigs';

type Result = Readonly<{
	/** Real share configs (copy + channels) flattened for the local-signer goal screen. */
	shareActions: readonly LocalShareAction[];
	/** The petition's relevant place (city or state, by reach), else undefined (component fallback). */
	location: string | undefined;
	/** The signer's first name for the goal greeting, when identified. */
	userName: string | undefined;
}>;

export function useConstituentShareData(): Result {
	const {
		data: { petition },
	} = usePsfSharePageData();
	const currentUser = useCurrentUser();

	const { data: shareActionsData } = useShareActions();
	const shareActions = useMemo<readonly LocalShareAction[]>(
		() => [shareActionsData.first, ...shareActionsData.rest].filter((a): a is ShareActionItem => Boolean(a)),
		[shareActionsData.first, shareActionsData.rest],
	);

	const location = useMemo(() => getLocalSignerLocation(petition), [petition]);

	return {
		shareActions,
		location,
		userName: currentUser?.firstName,
	};
}
